/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 * Adapted to use Tinybind logic
 *
 */

Shopify.theme.jsRecentlyView = (function() {

    var config = {
        howManyToShow: 10,
        howManyToStoreInMemory: 10,
        onComplete: null,
    };

    var selectors = {
        container: '#recently-viewed-products',
        list: '.recently-viewed-products__list',
    };

    var data = {
        products: [],
    };

    var productHandleQueue = [];
    var wrapper = null;
    var shown = 0;

    var cookie = {
        configuration: {
            expires: 90,
            path: '/',
            domain: window.location.hostname
        },
        name: 'shopify_recently_viewed',
        write: function(recentlyViewed) {
            localStorage.setItem(this.name, recentlyViewed.join(' '));
        },
        read: function() {
            var recentlyViewed = [];
            var cookieValue = localStorage.getItem(this.name);
            if (cookieValue !== null) {
                recentlyViewed = cookieValue.split(' ');
            }
            return recentlyViewed;
        },
        destroy: function() {
            localStorage.removeItem(this.name);
        },
        remove: function(productHandle) {
            var recentlyViewed = this.read();
            var position = $.inArray(productHandle, recentlyViewed);
            if (position !== -1) {
                recentlyViewed.splice(position, 1);
                this.write(recentlyViewed);
            }
        }
    };

    var moveAlong = function() {

        if (productHandleQueue.length && shown < config.howManyToShow && productHandleQueue[0] != '') {
            //console.log('/products/' + productHandleQueue[0] + '?view=json')
            $.ajax({
                url: '/products/' + productHandleQueue[0] + '?view=json',
                success: function(product) {
                    product = JSON.parse(product);
                    // console.log(product)

                    var currentProduct = theme.current.product && theme.current.product.handle;

                    if (currentProduct != product.handle) {
                        product.featured_image = {
                            src: product.featured_image,
                        };

                        for (var i = 0; i < product.images.length; i++) {
                            product.images[i] = {
                                src: product.images[i],
                            };
                        }

                        data.products.push(product);

                    }
                    productHandleQueue.shift();
                    shown++;
                    //console.log('NEW PRODUCT', data.products)
                    moveAlong();
                },
                error: function(error) {
                    console.log('ERROR', error)
                    // cookie.remove(productHandleQueue[0]);
                    productHandleQueue.shift();
                    moveAlong();
                }
            });
        } else {


            if (typeof config.onComplete === "function") {
                config.onComplete();
            }
            //console.log('CONTAINOS', selectors.container)
            //console.log('DATA', {data})
            window.prData = data
            tinybind.bind($(selectors.container), {
                products: data.products
            });

            document.querySelector(selectors.list).querySelectorAll('.product__grid-item').forEach(a => {
                    let found = false;
      
                    a.querySelectorAll('.thumbnail-sticker').forEach(sticker => {
                      if(!found) {
                        let pseudo = window.getComputedStyle(sticker, ':after');
                        if(pseudo.getPropertyValue("content") && pseudo.getPropertyValue("content") != "none") {
                          found = true;
                        }
                      }else {
                        sticker.remove();
                      }
                    })
            })

            var mobile =  ($(window).width() > 768);

            if (data.products.length > 4 &&  mobile || data.products.length > 2 && !mobile) {

                  var slider = $(selectors.list).flickity({

                      prevNextButtons:  mobile && data.products.length > 4,
                      freeScroll: true,
                      pageDots: false,
                      contain: true,
                      draggable: true,
                      cellAlign: 'left'
                  });

                  setTimeout(function () {
                      slider.flickity('resize');
                  },500);

                theme.utils.fixFlikityPrevNextButton(slider, '.recently-view-section');

                // document.querySelector(selectors.list).querySelectorAll('.product__grid-item').forEach(a => {
                //     window.stickerRemove && window.stickerRemove(a);
                // })

                if(window.innerWidth < 749) {
                    document.querySelector(selectors.list).querySelectorAll('.thumbnail-sticker').forEach(sticker => {
                        let pseudo = window.getComputedStyle(sticker, ':after');
                        if(pseudo.getPropertyValue("content") && pseudo.getPropertyValue("content") != "none") {
                            if(pseudo.getPropertyValue("content").length > 10) {
                                sticker.parentElement.style.top = '23px';
                                sticker.parentElement.style.right = '-23px';
                            }else if(pseudo.getPropertyValue("content").length > 7) {
                                sticker.parentElement.style.top = '16px';
                                sticker.parentElement.style.right = '-15px';
                            }
                        }
                    })
                }
            }
        }

    };

    return {

        showRecentlyViewed: function(params) {

            var params = params || {};

            // Update defaults.
            $.extend(config, params);

            // Read cookie.
            productHandleQueue = cookie.read();

            // How many products to show.
            config.howManyToShow = Math.min(productHandleQueue.length, config.howManyToShow);

            // If we have any to show.
            if (config.howManyToShow) {
                // Getting each product with an Ajax call and rendering it on the page.
                moveAlong();
            } else {
                $(selectors.container).hide();
            }

        },

        getConfig: function() {
            return config;
        },

        clearList: function() {
            cookie.destroy();
        },

        recordRecentlyViewed: function(params) {

            var params = params || {};

            // Update defaults.
            $.extend(config, params);

            // Read cookie.
            var recentlyViewed = cookie.read();

            // If we are on a product page.
            if (window.location.pathname.indexOf('/products/') !== -1) {

                // What is the product handle on this page.
                var productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                // In what position is that product in memory.
                var position = $.inArray(productHandle, recentlyViewed);
                // If not in memory.
                if (position === -1) {
                    // Add product at the start of the list.
                    recentlyViewed.unshift(productHandle);
                    // Only keep what we need.
                    recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
                } else {
                    // Remove the product and place it at start of list.
                    recentlyViewed.splice(position, 1);
                    recentlyViewed.unshift(productHandle);
                }

                // Update cookie.
                cookie.write(recentlyViewed);

            }

        }

    };

})();
